import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Image } from "react-bootstrap";
import "react-phone-number-input/style.css";
import { validateVendorPersonalInfo } from "../../utils/validation/vendor-info";
import customerInfoServices from "../../services/customer-profile-services";
import { toast } from "react-toastify";
import { handleErrors } from "../../utils/errorHandler";
import "react-phone-number-input/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";
import defaultProfileImage from "../../assets//images/profile-img-default.png";

const VendorProfile = () => {
  // const navigate = useNavigate();
  const [formData, setFormData] = useState({
    BusinessName: "",
    ContactName: "",
    PhoneNo: "",
    WhatsApp: "",
    AltEmail: "",
    AltPhoneNo: "",
    ProfileImagePreview: null,
    HouseNo: "",
    RoadName: "",
    Locality: "",
    Pincode: "",
    City: "",
    State: "",
  });
  const [imageError, setImageError] = useState("");
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  async function fetchProfileData() {
    try {
      const response = await customerInfoServices.getVendorProfileInfo();
      const data = response.data.result;
      setFormData({
        BusinessName: data.businessName || "",
        ContactName: data.contactName || "",
        PhoneNo: data.phoneNo || "",
        WhatsApp: data.whatsApp || "",
        AltEmail: data.altEmail || "",
        emailAddress: data.emailAddress || "",
        AltPhoneNo: data.altPhoneNo || "",
        ProfileImagePreview: data.profileImage || null,
        HouseNo: data.vendorAddress?.houseNo || "",
        RoadName: data.vendorAddress?.roadName || "",
        Locality: data.vendorAddress?.locality || "",
        Pincode: data.vendorAddress?.pincode || "",
        City: data.vendorAddress?.city || "",
        State: data.vendorAddress?.state || "",
      });
    } catch (error) {
      toast.error(handleErrors(error));
    }
  }

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async () => {
    const formErrors = validateVendorPersonalInfo(formData);
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      try {
        setIsSaving(true);
        setIsButtonDisabled(true);

        console.log("Sending Payload:", formData);
        const payload = {
          BusinessName: formData.BusinessName,
          ContactName: formData.ContactName,
          PhoneNo: formData.PhoneNo,
          AltEmail: formData.AltEmail,
          WhatsApp: formData.WhatsApp,
          AltPhoneNo: formData.AltPhoneNo,
          ProfileImage: formData.ProfileImage,
          vendorAddress: {
            HouseNo: formData.HouseNo,
            Locality: formData.Locality,
            City: formData.City,
            State: formData.State,
            Pincode: formData.Pincode,
            RoadName: formData.RoadName,
          },
        };
        console.log("Converted Payload:", payload);
        await customerInfoServices.updateVendorProfileInfo(payload);

        toast.success("Profile updated successfully!");
      } catch (error) {
        console.error("API Error:", error);
        toast.error(handleErrors(error));
      } finally {
        setIsSaving(false);
        setIsButtonDisabled(false);
      }
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const img = new window.Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = function () {
        if (img.width === 250 && img.height === 250) {
          setFormData((prevData) => ({
            ...prevData,
            ProfileImage: file,
            ProfileImagePreview: objectUrl,
          }));
          setImageError("");
        } else {
          setImageError("Image must be exactly 250x250 pixels.");
          URL.revokeObjectURL(objectUrl);
        }
      };

      img.src = objectUrl;
    }
  };

  return (
    <div className="personal-info">
      <div className="my-account-title">
        <h3>Personal Details</h3>
      </div>
      <div className="profile-info-wrap">
        <div class="vendor-left">
          <div className="profile-left-content">
            <Row>
              <Col xs={12} xl={6} lg={6} sm={6}>
                <Form.Group className="form-group">
                  <Form.Label>
                    Business Name<span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Your  Name*"
                    name="BusinessName "
                    value={formData.BusinessName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.BusinessName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.BusinessName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} xl={6} lg={6} sm={6}>
                <Form.Group className="form-group">
                  <Form.Label>
                    Contact Name<span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Your  Name*"
                    name="ContactName"
                    value={formData.ContactName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.ContactName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.ContactName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} xl={6} lg={6} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Phone Number<span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    maxLength="10"
                    name="PhoneNo"
                    placeholder="Enter your contact number"
                    value={formData.PhoneNo}
                    onChange={handleInputChange}
                    isInvalid={!!errors.PhoneNo}
                    disabled
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.PhoneNo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} xl={6} lg={6} sm={6}>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Your EmailAddress *"
                  name="emailAddress"
                  value={formData.emailAddress}
                />
              </Col>
              <Col xs={12} xl={6} lg={6} sm={6}>
                <Form.Label>Alternate Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Your AltEmail *"
                  name="AltEmail"
                  value={formData.AltEmail}
                  onChange={handleInputChange}
                  isInvalid={!!errors.AltEmail}
                />
              </Col>

              <Col xs={12} xl={6} lg={6} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label>WhatsApp Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="WhatsApp"
                    placeholder="Enter your WhatsApp number"
                    value={formData.WhatsApp}
                    onChange={handleInputChange}
                    isInvalid={!!errors.WhatsApp}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} xl={6} lg={6} sm={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Alternative Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    name="AltPhoneNo"
                    placeholder="Enter your AltPhone number"
                    value={formData.AltPhoneNo}
                    onChange={handleInputChange}
                    isInvalid={!!errors.AltPhoneNo}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
          <div className="profile-right-content">
            <div className="profile-image-upload">
              <label
                htmlFor="profileImageUpload"
                className="position-relative d-inline-block"
              >
                <Image
                  src={formData.ProfileImagePreview || defaultProfileImage}
                  alt="Profile"
                  className="border border-light rounded"
                  width={150}
                  height={150}
                  style={{ cursor: "pointer" }}
                />
                <FontAwesomeIcon
                  icon={faCamera}
                  size="lg"
                  className="position-absolute"
                  style={{
                    bottom: 5,
                    right: 5,
                    background: "#fff",
                    borderRadius: "50%",
                    padding: "6px",
                  }}
                />
              </label>
              <input
                type="file"
                id="profileImageUpload"
                accept="image/*"
                onChange={handleImageChange}
                style={{ display: "none" }}
              />
              {imageError && (
                <p className="text-danger text-center mb-3">{imageError}</p>
              )}
            </div>
          </div>
        </div>

        <div className="profile-info-fields">
          <h4>Permanent Address</h4>
          <Row>
            <Col xs={12} xl={3} lg={6} sm={6}>
              <Form.Label>
                House Number <span className="imp-star">*</span>
              </Form.Label>
              <Form.Group className="form-group">
                <Form.Control
                  type="text"
                  placeholder="Your House number *"
                  name="HouseNo"
                  value={formData.HouseNo}
                  onChange={handleInputChange}
                  isInvalid={!!errors.HouseNo}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.HouseNo}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} xl={3} lg={6} sm={6}>
              <Form.Label>
                Road Name<span className="imp-star">*</span>
              </Form.Label>
              <Form.Group className="form-group">
                <Form.Control
                  type="text"
                  // rows={5}
                  placeholder="Enter your Road Name *"
                  name="RoadName"
                  value={formData.RoadName}
                  onChange={handleInputChange}
                  isInvalid={!!errors.RoadName}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.RoadName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} xl={3} lg={6} sm={6}>
              <Form.Label>
                Locality Name<span className="imp-star">*</span>
              </Form.Label>
              <Form.Group className="form-group">
                <Form.Control
                  type="text"
                  // rows={5}
                  placeholder="Enter your Locality  Name *"
                  name="Locality"
                  value={formData.Locality}
                  onChange={handleInputChange}
                  isInvalid={!!errors.Locality}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.Locality}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} xl={3} lg={6} sm={6}>
              <Form.Label>
                City Name<span className="imp-star">*</span>
              </Form.Label>
              <Form.Group className="form-group">
                <Form.Control
                  type="text"
                  // rows={5}
                  placeholder="Enter your City  Name *"
                  name="City"
                  value={formData.City}
                  onChange={handleInputChange}
                  isInvalid={!!errors.City}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.City}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} xl={3} lg={6} sm={6}>
              <Form.Label>
                State<span className="imp-star">*</span>
              </Form.Label>
              <Form.Group className="form-group">
                <Form.Control
                  type="text"
                  // rows={5}
                  placeholder="Enter your State *"
                  name="State"
                  value={formData.State}
                  onChange={handleInputChange}
                  isInvalid={!!errors.State}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.State}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} xl={3} lg={6} sm={6}>
              <Form.Label>
                Pincode Number <span className="imp-star">*</span>
              </Form.Label>
              <Form.Group className="form-group">
                <Form.Control
                  type="text"
                  placeholder="Your Pincode  number *"
                  name="Pincode"
                  value={formData.Pincode}
                  onChange={handleInputChange}
                  isInvalid={!!errors.Pincode}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.Pincode}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </div>
      </div>
      <div className="save-btn">
        <Button
          type="button"
          onClick={handleSubmit}
          disabled={isButtonDisabled}
          className="btn pay-now-btn"
        >
          {isSaving ? "Saving..." : "Save Details"}
        </Button>
      </div>
    </div>
  );
};

export default VendorProfile;
